export { default as useUpdateIndexQueryItemCache } from './useUpdateIndexQueryItemCache';
export * from './useUpdateIndexQueryItemCache';
